import { parametersWatcher } from './parametersWatcher';
import GatedContent from "./gatedContent";
import {SMS} from "./SMS";

// Example data:
// {
//     image: '/wp-content/themes/electro/img/weather-bug/weather-sun.svg',
//     text: 'Today’s weather report: BBQ ahead! Try our recipe for',
//     cta: {
//         text: 'ribs',
//         link: '/ribs/',
//     },
//     disclaimer: {
//         text1: "*weather forecast provided by",
//         text2: "Openweathermap.org",
//         url: "https://openweathermap.org/"
//     }
// }

/**
 * ALl Google Optimize A/B Testing related functions.
 *
 * These functions are supposed to provide control over altering content on the website.
 * They are called by the Google Optimize A/B Testing platform.
 *
 */
export default class Optimize {
    constructor() {
        window.showHeaderBanner = this.showHeaderBanner;
        window.hideHeaderBanner = this.hideHeaderBanner;
        window.showRecipesClassicsCard = this.showRecipesClassicsCard;
        window.hideRecipesClassicsCard = this.hideRecipesClassicsCard;
        window.showRecommendationSliderCard = this.showRecommendationSliderCard;
        window.hideRecommendationSliderCard = this.hideRecommendationSliderCard;
        window.showProductsSliderCard = this.showProductsSliderCard;
        window.hideProductsSliderCard = this.hideProductsSliderCard;
        window.showRecipesSliderCard = this.showRecipesSliderCard;
        window.hideRecipesSliderCard = this.hideRecipesSliderCard;
        window.showCollectionsSliderCard = this.showCollectionsSliderCard;
        window.hideCollectionsSliderCard = this.hideCollectionsSliderCard;
        window.renderSignUpModalA = this.renderSignUpModalA;
        window.renderSignUpModalB = this.renderSignUpModalB;
        window.updateHomePageHeroCopy = this.updateHomePageHeroCopy;
        window.updateGatedContentStatus = this.updateGatedContentStatus;
        window.showWeatherNotification = this.showWeatherNotification;
        window.hideWeatherNotification = this.hideWeatherNotification;
        window.showSMSModalHomePage = this.showSMSModalHomePage;
        window.showSMSModalRDP = this.showSMSModalRDP;

        // Run the parameters watcher, for testing through URL parameters.
        parametersWatcher();
    }

    /**
     * Show the pencil banner, with a copy change.
     */
    showHeaderBanner(copy = null) {
        const pencilBanner = document.querySelector('.header-banner--signup');
        if (!pencilBanner) {
            return;
        }
        pencilBanner.style.display = 'block';
        if (copy) {
            const copyElement = pencilBanner.querySelector('.header-banner__content .banner__inner p');
            if (!copyElement) {
                return;
            }
            copyElement.innerHTML = copy;
        }
    }

    /**
     * Hides the pencil banner when called.
     */
    hideHeaderBanner() {
        const pencilBanner = document.querySelector('.header-banner--signup');
        if (!pencilBanner) {
            return;
        }
        pencilBanner.style.display = 'none';
    }

    /**
     * Show the recipes' classics card.
     */
    showRecipesClassicsCard() {
        // Hide the first recipe with class : kingsford-classics-list__recipe-card
        const firstRecipe = document.querySelector('.kingsford-classics-list__recipe-card.non-lytics');
        if (!firstRecipe) {
            return;
        }
        firstRecipe.style.display = 'none';

        // Show the Lytics card
        const signupCta = document.querySelector('.recipe-card--signup-cta');
        if (!signupCta) {
            return;
        }
        signupCta.style.display = 'flex';
    }

    /**
     * Hides the recipes' classics card.
     */
    hideRecipesClassicsCard() {
        // Show the all recipe cards.
        const allRecipesCards = document.querySelectorAll('.kingsford-classics-list__recipe-card.non-lytics');
        if (!allRecipesCards) {
            return;
        }
        allRecipesCards.forEach((recipe) => {
            recipe.style.display = 'flex';
        });

        // Hide the Lytics card.
        const signupCta = document.querySelector('.recipe-card--signup-cta');
        if (!signupCta) {
            return;
        }
        signupCta.style.display = 'none';
    }

    /**
     * Show the recommendation's slider's lytics card.
     */
    showRecommendationSliderCard() {
        // get all sections with id prefix "recommendation-slider--"
        let recommendationSliders = document.querySelectorAll('[id^="recommendation-slider--"]');
        if (!recommendationSliders) {
            return false;
        }
        recommendationSliders = Array.from(recommendationSliders);
        if (recommendationSliders.length < 1) {
            return false;
        }

        // Show all the slides(including the duplicate ones).
        recommendationSliders.forEach((slider) => {
            Array.from(slider.querySelectorAll('.slide--lytics-card')).forEach((slide) => {
                slide.classList.remove('lytics-disable');
            });
        });
    }

    /**
     * Hides the recommendation's slider's lytics card.
     */
    hideRecommendationSliderCard() {
        // get all sections with id prefix "recommendation-slider--"
        let recommendationSliders = document.querySelectorAll('[id^="recommendation-slider--"]');
        if (!recommendationSliders) {
            return false;
        }
        recommendationSliders = Array.from(recommendationSliders);
        if (recommendationSliders.length < 1) {
            return false;
        }

        // Hide all the slides(including the duplicate ones).
        recommendationSliders.forEach((slider) => {
            Array.from(slider.querySelectorAll('.slide--lytics-card')).forEach((slide) => {
                slide.classList.add('lytics-disable');
            });
        });
    }

    /**
     * Show the Products slider's lytics card.
     */
    showProductsSliderCard() {
        // get all sections with id prefix "recommendation-slider--"
        let sliders = document.querySelectorAll('[id^="product-carousel--"]');
        if (!sliders) {
            return false;
        }
        sliders = Array.from(sliders);
        if (sliders.length < 1) {
            return false;
        }

        // Show all the slides(including the duplicate ones).
        sliders.forEach((slider) => {
            Array.from(slider.querySelectorAll('.slide--lytics-card')).forEach((slide) => {
                slide.classList.remove('lytics-disable');
            });
        });
    }

    /**
     * Hides the Products slider's lytics card.
     */
    hideProductsSliderCard() {
        // get all sections with id prefix "recommendation-slider--"
        let sliders = document.querySelectorAll('[id^="product-carousel--"]');
        if (!sliders) {
            return false;
        }
        sliders = Array.from(sliders);
        if (sliders.length < 1) {
            return false;
        }

        // Hide all the slides(including the duplicate ones).
        sliders.forEach((slider) => {
            Array.from(slider.querySelectorAll('.slide--lytics-card')).forEach((slide) => {
                slide.classList.add('lytics-disable');
            });
        });
    }

    /**
     * Show the Recipes slider's lytics card.
     */
    showRecipesSliderCard() {
        // get all sections with id prefix "recommendation-slider--"
        let sliders = document.querySelectorAll('[id^="recipe-carousel--"]');
        if (!sliders) {
            return false;
        }
        sliders = Array.from(sliders);
        if (sliders.length < 1) {
            return false;
        }

        // Show all the slides(including the duplicate ones).
        sliders.forEach((slider) => {
            Array.from(slider.querySelectorAll('.slide--lytics-card')).forEach((slide) => {
                slide.classList.remove('lytics-disable');
            });
        });
    }

    /**
     * Hides the Recipes slider's lytics card.
     */
    hideRecipesSliderCard() {
        // get all sections with id prefix "recommendation-slider--"
        let sliders = document.querySelectorAll('[id^="recipe-carousel--"]');
        if (!sliders) {
            return false;
        }
        sliders = Array.from(sliders);
        if (sliders.length < 1) {
            return false;
        }

        // Hide all the slides(including the duplicate ones).
        sliders.forEach((slider) => {
            Array.from(slider.querySelectorAll('.slide--lytics-card')).forEach((slide) => {
                slide.classList.add('lytics-disable');
            });
        });
    }

    /**
     * Show the Collections slider's lytics card.
     */
    showCollectionsSliderCard() {
        // get all sections with id prefix "recommendation-slider--"
        let sliders = document.querySelectorAll('[id^="recipe-collection-carousel--"]');
        if (!sliders) {
            return false;
        }
        sliders = Array.from(sliders);
        if (sliders.length < 1) {
            return false;
        }

        // Show all the slides(including the duplicate ones).
        sliders.forEach((slider) => {
            Array.from(slider.querySelectorAll('.slide--lytics-card')).forEach((slide) => {
                slide.classList.remove('lytics-disable');
            });
        });
    }

    /**
     * Hides the Collections slider's lytics card.
     */
    hideCollectionsSliderCard() {
        // get all sections with id prefix "recommendation-slider--"
        let sliders = document.querySelectorAll('[id^="recipe-collection-carousel--"]');
        if (!sliders) {
            return false;
        }
        sliders = Array.from(sliders);
        if (sliders.length < 1) {
            return false;
        }

        // Hide all the slides(including the duplicate ones).
        sliders.forEach((slider) => {
            Array.from(slider.querySelectorAll('.slide--lytics-card')).forEach((slide) => {
                slide.classList.add('lytics-disable');
            });
        });
    }

    renderSignUpModalA() {
        if (document.querySelectorAll('form.register').length > 1 && document.querySelector('.signup-form-variant-b')) {
            document.querySelector('.signup-form-variant-b').remove();
        }
    }

    renderSignUpModalB() {
        if (document.querySelectorAll('form.register').length > 1 && document.querySelector('.signup-form-variant-a')) {
            document.querySelector('.signup-form-variant-a').remove();
        }
    }

    updateHomePageHeroCopy(lyticsSegment) {
        const segmentationMap = JSON.parse(document.querySelector('input.lytics-segmentation-hero').value);
        if (lyticsSegment && segmentationMap) {
            const segment = segmentationMap.find((o) => o.lytics_segment === lyticsSegment);
            const hero = document.querySelector('.b-split-hero');
            hero.querySelector('.b-split-hero__title').innerText = segment.values.title;
            hero.querySelector('.b-split-hero__subtitle').innerText = segment.values.subtitle;
            if (hero.querySelectorAll('.b-split-hero__cta-wrapper__cta').length > 1) {
                $('.b-split-hero__cta-wrapper__cta').each((i, e) => {
                    if (i > 0) {
                        e.remove();
                    }
                });
            }
            hero.querySelector('.b-split-hero__cta-wrapper__cta .e-button__copy').innerText = segment.values.cta_text;
            hero.querySelector('.b-split-hero__cta-wrapper__cta .e-button__copy').classList.remove('js-user-account');
            hero.querySelector('.b-split-hero__cta-wrapper__cta').href =
                `/?registerModal=1&lytics_campaign=${  segment.lytics_crm}`;
        }
    }

    updateGatedContentStatus() {
        new GatedContent().show();
    }

    /**
     * Shows the weather notification, only if html is passed to it.
     *
     * Example: `Grill-friendly weather alert! It’s the perfect week to make <a href="/grill-basics/how-to-smoke-a-brisket/">brisket</a>`
     * @param html
     * @returns {boolean}
     */
    showWeatherNotification(html = null) {
        if (Electro.DEBUG) {
            console.info('WeatherNotification.showHeaderBanner()');
        }

        const weatherBanner = document.querySelector('.js-weather-banner');
        if (
            weatherBanner &&
            html.image &&
            html.text &&
            html.cta.link &&
            html.cta.text &&
            html.disclaimer.text1 &&
            html.disclaimer.text2 &&
            html.disclaimer.url
        ) {
            console.info('true');
            // Update the html
            const htmlBody = weatherBanner.querySelector('.b-weather-notification__content');

            const notification = `
                <img class="content__image" src="${html.image}"/>
                <div class="content__wrapper">
                    <span class="content__body">${html.text} <a href="${html.cta.link}" target="_blank">${html.cta.text}</a></span>
                    <span class="content__disclaimer">${html.disclaimer.text1} <a href="${html.disclaimer.url}" target="_blank">${html.disclaimer.text2}</a></span>
                </div>
                <button class="content__close js-close-weather-banner">
                    <img src="/wp-content/themes/electro/img/weather-bug/close.svg"/>
                    <span class="visibility-hidden">Close</span>
                </button>
            `;
            htmlBody.innerHTML = notification;

            weatherBanner.classList.add('is-active');
            weatherBanner.classList.remove('is-inactive');

            const closeBtn = weatherBanner.querySelector('.js-close-weather-banner');
            closeBtn.addEventListener('click', () => {
                weatherBanner.classList.remove('is-active');
                weatherBanner.classList.add('is-inactive');
            });
        }

        return true;
    }

    hideWeatherNotification() {
        if (Electro.DEBUG) {
            console.info('WeatherNotification.hideWeatherNotification()');
        }

        const weatherBanner = document.querySelector('.js-weather-banner');
        if (weatherBanner) {
            weatherBanner.classList.remove('is-active');
            weatherBanner.classList.add('is-inactive');
        }
    }

    /**
     * Show the SMS popup on homepage.
     */
    showSMSModalHomePage() {
        console.log('showSMSModalHomePage');
        SMS.triggerModal();
    }

    /**
     * Show the SMS popup on recipe page.
     */
    showSMSModalRDP() {
        SMS.triggerModal();
    }
}
